import React from "react";
import PropTypes from "prop-types";
import { Form, Input } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { Controller } from "react-hook-form";

const AddReportCategoryRow = ({ index, errors, control, remove }) => {
  return (
    <Form.Item
      {...(index === 0 ? { label: "Report Category" } : {})}
      validateStatus={errors?.categories?.[index]?.name ? "error" : ""}
      help={errors?.categories?.[index]?.name?.message ?? ""}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          gap: 10,
          alignItems: "center",
        }}
      >
        <Controller
          name={`categories.${index}.name`}
          control={control}
          render={({ field: { onChange, onBlur, value } }) => (
            <Input onBlur={onBlur} onChange={onChange} value={value} />
          )}
        />
        <CloseOutlined
          style={{ color: "#CB1F1F" }}
          onClick={() => remove(index)}
        />
      </div>
    </Form.Item>
  );
};

AddReportCategoryRow.propTypes = {};

export default AddReportCategoryRow;
